// @flow

import isNil from 'lodash.isnil';
import type {RequestParams} from '../typedef';

type PrepareQueryParams = (data: { params: RequestParams, url: string }) => {
    url: string,
};


const prepareValues = value => (Array.isArray(value) ? value : [value]).map(encodeURIComponent).join();
export const prepareQueryParams: PrepareQueryParams = ({url, params}) => {
    let entries = '';
    const keys = Object.keys(params);
    if (keys.length) {
        const valuesList = [];
        for (let index = 0; index < keys.length; index++) {  
            const keyValue = keys[index];
            const value = params[keyValue];
            if (!isNil(value)) {
                valuesList.push(`${keyValue}=${prepareValues(value)}`);
            }
        }
        entries = valuesList.join('&');
    }
    return entries ? {url: `${url}?${entries}`} : {url};
};


            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
